import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.254 4.284A2.68 2.68 0 0 1 8.147 3.5h7.706a2.677 2.677 0 0 1 2.677 2.677v12.736h1.97a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1 0-1.5h1.97V6.177c0-.71.282-1.391.784-1.893m.716 14.63h10.06V6.176A1.177 1.177 0 0 0 15.853 5H8.147A1.177 1.177 0 0 0 6.97 6.177zm6.28-6.965a.75.75 0 0 1 .757-.742l1 .01a.75.75 0 0 1-.014 1.5l-1-.01a.75.75 0 0 1-.743-.758" fill="currentColor"/>' }
  })
);